import FacturarPage from "./GenerarFacturasPage";

export {FacturarPage}
export default FacturarPage
